window.urlFormatter = function(value, row) {
    let html = '';
    if (value) {
        let url = value.replace(/^(https?:\/\/)?(www\.)?/i, '');
        html += '<a href="'+value+'" target="_blank" rel="noopener noreferrer">';
        html += '<i class="fal fa-external-link me-2"></i>';
        html += url;
        html += '</a>';
    }
    return html;
}